/**
 * Remembers the customer's Theta Lake portal URL across the OAuth redirect.
 *
 * The customer types their portal URL to start the connect. It is needed twice and the two are
 * separated by a full round trip to Theta Lake:
 *
 *   1. on the authorize redirect, as the `theta_lake_portal_url` query parameter
 *   2. on the settings POST afterwards, so the backend can store it in the auth blob
 *
 * Theta Lake returns `code`, `api_url` and `state` — not the portal URL — so it cannot be
 * recovered from the callback query string and has to be held on our side. `state` would
 * technically round-trip it, but overloading a parameter meant for CSRF with data the backend
 * then has to parse is worse than a named store.
 *
 * sessionStorage rather than localStorage: it is scoped to the tab doing the connect and clears
 * itself when that tab closes, so an abandoned connect cannot leak into a later one.
 *
 * Every access is wrapped — private browsing and some embedded webviews throw on access rather
 * than returning null, and a storage failure should degrade the connect, not break the page.
 */
const KEY = 'thetalake_portal_url';

export function setPortalUrl(portalUrl) {
    try {
        window.sessionStorage.setItem(KEY, portalUrl);
        return true;
    } catch (e) {
        console.error('Could not store the Theta Lake portal URL', e);
        return false;
    }
}

export function getPortalUrl() {
    try {
        return window.sessionStorage.getItem(KEY);
    } catch (e) {
        console.error('Could not read the Theta Lake portal URL', e);
        return null;
    }
}

export function clearPortalUrl() {
    try {
        window.sessionStorage.removeItem(KEY);
    } catch (e) {
        console.error('Could not clear the Theta Lake portal URL', e);
    }
}
